import {ImageLoaderConfig} from "@angular/common";
import {environment} from "../../../environments/environment";
import {getRuntimeApiUrl} from './runtime-api-url';

type ReusableImageLoaderConfig = Pick<ImageLoaderConfig, 'src'> & Partial<Pick<ImageLoaderConfig, 'width'>>;

export function loadMediaUrl(config: ReusableImageLoaderConfig): string {
  if (config.src.indexOf('assets/images/') !== -1) {
    return config.src;
  }

  // can't inject services here, so we need to read persisted token directly
  if (document.cookie.match(/(^|;\s*)token=([^;]*)/)) {
    document.cookie = 'token=; path=/; max-age=0; SameSite=Lax';
  }
  const tokenFromLocalStorage = (() => {
    try {
      return localStorage.getItem('hs_token') ?? '';
    } catch {
      return '';
    }
  })();
  const token = tokenFromLocalStorage || undefined;
  const queryPrefix = config.src.includes('?') ? '&' : '?';
  return getRuntimeApiUrl(environment.api) +
    config.src +
    (token && config.width ?
      queryPrefix + 'width=' + config.width + '&token=' + token :
      token && !config.width ?
        queryPrefix + 'token=' + token :
        !token && config.width ?
          queryPrefix + 'width=' + config.width :
          ''
    );
}
